

// 引入公共文件
import { errorModal } from '../../../assets/js/xjcommon';

import { Cell, CellGroup, Switch, Slider, RadioGroup, Radio, Popup, Field, TreeSelect, Picker } from 'vant'

export default {
  name: 'notification',
  components: {
    [Cell.name]: Cell,
    [CellGroup.name]: CellGroup,
    [Switch.name]: Switch,
  },
  data () {
    return {
      // 当前IMEI
      nowImei: $cookies.get('imei'),
      // 车辆信息数据
      bdNickNameSet: '',
      bdCarType: '',
      bdCarBrandAndModel: '',
      bdCarLicense: '',
      settingItem:[{
        item:"报警提醒",
        key:'alarmNotify',
        value:false,
      },{
        item:"抓拍照片",
        key:'snapshotNotify',
        value:false,
      },{
        item:"行程报告",
        key:'travelNotify',
        value:false,
      }]
    }
  },
  methods: {
    initDevInfoFn(){

      this.$axios.post('/v3/u/user/getNoticeConfiguration').then(res=>{
        const data =res.data.data;
        this.settingItem = this.settingItem.map(item=>({...item,value:data[item.key]}))
      })
    },
    boolChange(value,key){
      const reqData = this.settingItem.reduce((t,item)=>({...t,[item.key]:item.value}),{})
      this.updateDevInfoFn({...reqData,[key]:value},{key,value})
    },

    updateSettingItemValue(cmd,value){
      this.settingItem = this.settingItem.map(item=>({...item,value:item.key===cmd?value:item.value}))
    },

    // 更新设置
    updateDevInfoFn (reqData,editItem) {
      this.$toast.loading({
        overlay: true,
        duration: 0,
        message: '更新中...'
      });

      this.$axios.post('/v3/u/user/setNoticeConfiguration', reqData).then((response)=>{
          this.$toast.clear();
          if (response.data.ret === 0) {
            this.$toast({
              message: '更新成功'
            })
            this.updateSettingItemValue(editItem.key,editItem.value)
          } else {
            this.$dialog({
              message: response.data.msg ? response.data.msg + '（' + response.data.ret + '）' : '更新失败（' + response.data.ret + '）'
            })
          }
        })
        .catch((error)=>{
          this.$toast.clear();
          errorModal(error, 163);
        })
    },
  },
  mounted () {
    window.scrollTo(0,0);
    this.initDevInfoFn();
  }
}
